import { SportsMessageChannels } from "../message";
export const QueryTypes = SportsMessageChannels;
export var TimeRange;
(function (TimeRange) {
    TimeRange["OneHour"] = "OneHour";
    TimeRange["TwoHours"] = "TwoHours";
    TimeRange["ThreeHours"] = "ThreeHours";
    TimeRange["SixHours"] = "SixHours";
    TimeRange["TwelveHours"] = "TwelveHours";
    TimeRange["OneDay"] = "OneDay";
    TimeRange["TwoDays"] = "TwoDays";
    TimeRange["ThreeDays"] = "ThreeDays";
    TimeRange["FourDays"] = "FourDays";
    TimeRange["FiveDays"] = "FiveDays";
    TimeRange["SixDays"] = "SixDays";
    TimeRange["SevenDays"] = "SevenDays";
})(TimeRange || (TimeRange = {}));
export var EventState;
(function (EventState) {
    EventState["Live"] = "Live";
    EventState["PreLive"] = "PreLive";
    EventState["Mixed"] = "Mixed";
})(EventState || (EventState = {}));
export var EventTags;
(function (EventTags) {
    EventTags["LiveStreaming"] = "LiveStreaming";
    EventTags["FastMarket"] = "FastMarket";
    EventTags["Stats"] = "Stats";
})(EventTags || (EventTags = {}));
export var LeagueState;
(function (LeagueState) {
    LeagueState["Regular"] = "Regular";
    LeagueState["Mixed"] = "Mixed";
})(LeagueState || (LeagueState = {}));
export var MarketTypeRequestStatement;
(function (MarketTypeRequestStatement) {
    MarketTypeRequestStatement["Include"] = "Include";
    MarketTypeRequestStatement["Exclude"] = "Exclude";
})(MarketTypeRequestStatement || (MarketTypeRequestStatement = {}));
export var EventTypes;
(function (EventTypes) {
    EventTypes["Fixture"] = "Fixture";
    EventTypes["Outright"] = "Outright";
    EventTypes["AntePostRace"] = "AntePostRace";
    EventTypes["AggregateFixture"] = "AggregateFixture";
})(EventTypes || (EventTypes = {}));
//# sourceMappingURL=sportsbook.js.map